export default "__VITE_ASSET__dM5j2RX1__"